import type { Key } from "react";
import type {
  ICreateMode,
  IChangingMode,
  IOfferFieldName,
  IOfferFieldNameRule,
} from "../../../../../lib/types";
import { OFFER_STATUSES, OFFER_TYPES } from "../../../../../store/slices/offering/const";

// !При добавлении версии, в качестве статус предложения берется статус версии - основания

const { PREPARE, SUSPENDED, ACTIVE, ARCHIVE, ARCHIVE_PROLONGABLE } = OFFER_STATUSES;

// Template
// create: {
//   [PREPARE]: ,
//   [SUSPENDED]: ,
//   [ACTIVE]: ,
//   [ARCHIVE]: ,
// },

// Доступность полей к редактированию по схеме: имя поля => режим измененения => статус предложения => правило доступности
export const isFieldAvailable = (params: {
  fieldName: IOfferFieldName;
  viewMode: ICreateMode | IChangingMode;
  offeringStatusId: number;
  options?: { [key: Key]: any };
}): boolean => {
  const { fieldName, viewMode, offeringStatusId, options } = params;
  const fieldNameRules: IOfferFieldNameRule = {
    extName: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
    },
    name: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
      },
    },
    periodAlignmentId: {
      create: {
        [PREPARE]: options?.tariffModelId !== 2,
      },
      edit: {
        [PREPARE]: options?.tariffModelId !== 2,
        [SUSPENDED]: options?.tariffModelId !== 2,
      },
      add: {
        [PREPARE]: options?.tariffModelId !== 2,
        [SUSPENDED]: options?.tariffModelId !== 2,
      },
    },
    tariffModelId: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    offeringStatusId: {
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
      },
    },
    isStandalone: {
      create: {
        [PREPARE]: !options?.isRoot,
        [SUSPENDED]: !options?.isRoot,
        [ACTIVE]: !options?.isRoot,
        [ARCHIVE]: !options?.isRoot,
        [ARCHIVE_PROLONGABLE]: !options?.isRoot,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]:
          options?.addVersionStatusId !== ARCHIVE &&
          options?.addVersionStatusId !== ARCHIVE_PROLONGABLE,
        [SUSPENDED]:
          options?.addVersionStatusId !== ARCHIVE &&
          options?.addVersionStatusId !== ARCHIVE_PROLONGABLE,
        [ACTIVE]:
          options?.addVersionStatusId !== OFFER_STATUSES.ARCHIVE &&
          options?.addVersionStatusId !== ARCHIVE_PROLONGABLE,
      },
    },
    prolongTypeId: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
    },
    lifespanPeriodId: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    lifespanPeriodQty: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    offeringTypeId: {
      create: {},
    },
    agreementId: {
      create: {},
      edit: {
        [PREPARE]: options?.offeringTypeId === OFFER_TYPES.PERSONAL,
      },
      add: {
        [PREPARE]: options?.offeringTypeId === OFFER_TYPES.PERSONAL,
      },
    },
    fromDate: {
      create: {
        [PREPARE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
    },
    toDate: {
      create: {
        [PREPARE]: true,
      },
      close: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
    },
    bundleTypeId: {
      create: {},
    },
  };
  return Boolean(fieldNameRules[fieldName]?.[viewMode]?.[offeringStatusId]);
};
